import { DateTime } from '../../../utils/DateTime';

export const getCurrentDateWithDashFormatting = () => {
  const today = DateTime.getCurrentDateTime();
  const yy = today.getFullYear();
  const mm = today.getMonth() + 1;
  const dd = today.getDate();
  return `${mm}-${dd}-${yy}`;
};
